import { useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { EmailVerificationSuccess } from "./components"

/**
 * Handles the completion of the freemium signup process.
 * When the user clicks the link sent to their email, 
 * they will be redirected to this page to complete their registration.
 * 
 * If the user is authenticated and not in the "Trialing" onboarding stage, 
 * they will be redirected to the homepage.
 * If no token is provided in the URL, they will be redirected to the freemium signup page.
 * 
 * Renders an email verification success component if a valid token is found.
 */

const CompleteFreemiumSignupPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const auth = useSelector((state) => state.auth);
  
  useEffect(() => {
    if (auth.isAuthenticated && auth.onboardingStage !== "Trialing") {
      navigate("/");
    } else if (!token) {
      navigate("/freemium-signup");
    }
  }, [auth, token, navigate]);

  if (token) {
    return <EmailVerificationSuccess token={token} />;
  }
}

export default CompleteFreemiumSignupPage